{
  "w": 24,
  "h": 32,
  "rows": [
    "........................",
    "...........WW...........",
    "..........WWWW..........",
    "...........WW...........",
    "...YYYYYYYYYYYYYYYYYWYYY",
    "...YYYYYYYYYYYYYYYYYYYYY",
    "...YYKKKKKKKKKKKKKKKKKYY",
    "...YyyyyyyyyyyyyyyyyyyyY",
    "........................",
    "...........RR...........",
    "YYYWYYYYYYYYYYYYYYYYYY..",
    "YYYYYYYYYYYYYYYYYYYYYY..",
    "YYKKKKKKKKKKKKKKKKKKYY..",
    "YyyyyyyyyyyyyyyyyyyyyY..",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "...........RR...........",
    "........WWWWWWWWW......."
  ],
  "legend": {
    "K": "C.BLACK",
    "R": "C.RED",
    "Y": "C.B_YELLOW",
    "y": "C.YELLOW",
    "W": "C.B_WHITE"
  }
}
